/* ============
 * The initial state of the patient module.
 * ============
 */
export default {
  loading: false,
  patientList: [],
  patient: {},
  error: null,
  totalCount: 0,
  patienStatusCount: [],
  assignedCareplan: {},
  isPatientEhrLoading: false,
  isPatientListloading: false
};
